module.exports = __webpack_public_path__ + "static/media/preset3.e68b7508.svg";